import PageSEO from "@/components/PageSEO";
import StickyHeader from "@/components/StickyHeader";
import HeroBanner from "@/components/HeroBanner";
import HeadingSection from "@/components/HeadingSection";
import PromotionsSection from "@/components/PromotionsSection";
import BrandPartners from "@/components/BrandPartners";
import SystemTypes from "@/components/SystemTypes";
import ComfortSection from "@/components/ComfortSection";
import ACGExperience from "@/components/ACGExperience";
import ACGGuarantee from "@/components/ACGGuarantee";
import ACGMission from "@/components/ACGMission";
import InterestFree from "@/components/InterestFree";
import HomeClimateGuide from "@/components/HomeClimateGuide";
import HomeChoosingSystem from "@/components/HomeChoosingSystem";
import HomeLocalFAQ from "@/components/HomeLocalFAQ";

import Testimonials from "@/components/Testimonials";
import CTAFooter from "@/components/CTAFooter";

const Index = () => {
  return (
    <main className="min-h-screen bg-background">
      <PageSEO title="ACG Southern Highlands | Heating & Air Conditioning" description="Heating & Air Conditioning | ACG Southern Highlands" />
      <StickyHeader />
      <HeroBanner />
      <HeadingSection />
      <PromotionsSection />
      <BrandPartners />
      <SystemTypes />
      <HomeClimateGuide />
      <ComfortSection />
      <HomeChoosingSystem />
      <ACGExperience />
      <ACGGuarantee />
      <ACGMission />
      <InterestFree />
      <HomeLocalFAQ />

      <Testimonials />
      <CTAFooter />
    </main>
  );
};

export default Index;
